var _defs, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg18Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.33 61.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5.16px;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "18-plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 30.67,
    cy: 30.67,
    r: 27.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.21,40.73h-4V24.92l-3.94,1.52V23.09L20.78,20h.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.22,25.53a5.47,5.47,0,0,1-.64,2.67,5,5,0,0,1-1.76,1.86,5.34,5.34,0,0,1,2,2,5.86,5.86,0,0,1,.74,3A5.9,5.9,0,0,1,36,39.41,5.84,5.84,0,0,1,31.65,41a5.94,5.94,0,0,1-4.36-1.6,5.84,5.84,0,0,1-1.62-4.36,5.88,5.88,0,0,1,.74-3,5.19,5.19,0,0,1,2-2,4.92,4.92,0,0,1-1.78-1.86A5.46,5.46,0,0,1,26,25.53a5.78,5.78,0,0,1,1.52-4.25,5.49,5.49,0,0,1,4.08-1.54,5.45,5.45,0,0,1,4.09,1.55A5.82,5.82,0,0,1,37.22,25.53ZM31.65,37.67A1.56,1.56,0,0,0,33,36.9a4,4,0,0,0,.49-2.15A3.92,3.92,0,0,0,33,32.58a1.66,1.66,0,0,0-2.82,0,3.87,3.87,0,0,0-.52,2.16,3.84,3.84,0,0,0,.52,2.15A1.64,1.64,0,0,0,31.65,37.67Zm1.56-11.93a4.08,4.08,0,0,0-.39-1.93,1.28,1.28,0,0,0-1.2-.73,1.27,1.27,0,0,0-1.17.7,4,4,0,0,0-.4,2,4.18,4.18,0,0,0,.4,2,1.28,1.28,0,0,0,1.19.75,1.25,1.25,0,0,0,1.18-.75A4.31,4.31,0,0,0,33.21,25.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.12,29.37h3.7V32h-3.7v4.18H44.3V32H40.58V29.37H44.3v-4h2.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18Plus);
export default __webpack_public_path__ + "static/media/18-plus.a33400b5320928c3f79b8646553c4f91.svg";
export { ForwardRef as ReactComponent };